export default __webpack_public_path__ + "static/media/Active_User.2577aaa7.svg";